import React from 'react'
import { Redirect } from 'react-router-dom'

import dashboardRoutes from './views/dashboard/DashboardRoutes'
import klientListRoutes from './views/klientList/KlientListRoutes'
import orderListRoutes from './views/order/OrderRouter'
import catalogListRoutes from './views/catalog/CatalogRouter'
import utilitiesRoutes from './views/utilities/UtilitiesRoutes'
import referenceRoutes from './views/reference/ReferenceRoutes'
import marketingRoutes from "./views/marketing/MarketingRoutes";
// import wtf from "./views/marketing/reclamation/Disturbance/WTF";
import profileRoutes from './views/profile/ProfileRoutes'

import materialRoutes from './views/material-kit/MaterialRoutes'
import chartsRoute from './views/charts/ChartsRoute'
import dragAndDropRoute from './views/Drag&Drop/DragAndDropRoute'
import invoiceRoutes from './views/invoice/InvoioceRoutes'
import calendarRoutes from './views/calendar/CalendarRoutes'
import crudRoute from './views/CRUD/CrudRoutes'
import inboxRoute from './views/inbox/InboxRoutes'
import formsRoutes from './views/forms/FormsRoutes'
import mapRoutes from './views/map/MapRoutes'
import chatRoutes from './views/chat-box/ChatRoutes'
import todoRoutes from './views/todo/TodoRoutes'
import pageLayoutRoutes from './views/page-layouts/PageLayoutRoutees'
import ListRoute from './views/list/ListRoute'

import pricingRoutes from './views/pricing/PricingRoutes'
import scrumBoardRoutes from './views/scrum-board/ScrumBoardRoutes'
import ecommerceRoutes from './views/ecommerce/EcommerceRoutes'
import pagesRoutes from './views/pages/pagesRoutes'
import dataTableRoutes from './views/data-table/dataTableRoutes'
import moneyRoutes from "./views/money/MoneyRoutes";
import accessRightsSettingsRoutes from "./views/AccessRightsSettings/AccessRightsSettingsRoutes";
import printSettingsPageRoutes from "./views/PrintSettingsPage/PrintSettingsPageRoutes";
import WarehouseRoutes from "./views/warehouse/WarehouseRoutes";
import deliveryZonesRoutes from "./views/Settings/DeliveryZones/DeliveryZonesRoutes";
import bonusSystemRoutes from "./views/Settings/BonusSystem/BonusSystemRoutes";
import generalSettingsRoutes from "./views/Settings/General/GeneralSettingsRoutes";
import telephonySettingsRoutes from "./views/Settings/Telephony/TelephonySettingsRoutes";
import frontpadSyncRoutes from "./views/Settings/FrontpadSync/FrontpadSyncRoutes";
import brandSettingsRoutes from "./views/Settings/Brands/BrandSettingsRoutes";
import siteCatalogSyncRoutes from "./views/Settings/SiteCatalogSync/SiteCatalogSyncRoutes";
import barcodeSettingsRoutes from "./views/Settings/Barcode/BarcodeSettingsRoutes";
import superAdminRoutes from './views/SuperAdmin/SuperAdminRoutes'
import dataExportRoutes from './views/DataExport/DataExportRoutes'

const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/dashboard/statsOrder" />,
    },
]

const errorRoute = [
    {
        component: () => <Redirect to="/session/404" />,
    },
]

const routes = [
    ...dashboardRoutes,
    ...klientListRoutes,
    // ...wtf,
    ...moneyRoutes,
    ...accessRightsSettingsRoutes,
    ...printSettingsPageRoutes,
    ...WarehouseRoutes,
    ...deliveryZonesRoutes,
    ...bonusSystemRoutes,
    ...generalSettingsRoutes,
    ...telephonySettingsRoutes,
    ...frontpadSyncRoutes,
    ...brandSettingsRoutes,
    ...siteCatalogSyncRoutes,
    ...barcodeSettingsRoutes,
    ...superAdminRoutes,
    ...dataExportRoutes,
    ...referenceRoutes,
    ...marketingRoutes,
    ...orderListRoutes,
    ...catalogListRoutes,
    ...materialRoutes,
    ...utilitiesRoutes,
    ...chartsRoute,
    ...dragAndDropRoute,
    ...calendarRoutes,
    ...invoiceRoutes,
    ...crudRoute,
    ...inboxRoute,
    ...formsRoutes,
    ...mapRoutes,
    ...chatRoutes,
    ...todoRoutes,
    ...scrumBoardRoutes,
    ...ecommerceRoutes,
    ...pageLayoutRoutes,
    ...pricingRoutes,
    ...ListRoute,
    ...pagesRoutes,
    ...dataTableRoutes,
    ...profileRoutes,
    ...redirectRoute,
    ...errorRoute,
]

export default routes
